import { keyframes } from "styled-components";
var fadeInSlideIn = function fadeInSlideIn(value) {
  return keyframes(["from{transform:", ";opacity:0;}to{transform:translateY(0);opacity:1;}"], "translateY(".concat(value || "100vh", ")"));
};
export default fadeInSlideIn;